

(function () {
  "use strict";
  console.log("Fitment Widget Loaded with Custom Selects - COMPLETE FIXED VERSION");

  /* ===========================
       CUSTOM SELECT CLASS - FIXED TO ACTUALLY WORK
    =========================== */
  class CustomSelect {
    constructor(container, options = {}) {
      this.container = typeof container === 'string' 
        ? document.querySelector(container) 
        : container;
      
      if (!this.container) {
        console.error('CustomSelect: Container element not found');
        return;
      }

      this.options = {
        onChange: null,
        allowClear: false,
        searchable: true,
        ...options
      };

      this.init();
    }

    init() {
      // Get elements
      this.wrapper = this.container;
      this.containerEl = this.wrapper.querySelector('.custom-select-container');
      this.trigger = this.wrapper.querySelector('.custom-select-trigger');
      this.dropdown = this.wrapper.querySelector('.custom-select-dropdown');
      this.nativeSelect = this.wrapper.querySelector('.custom-select-native');
      this.triggerText = this.wrapper.querySelector('.custom-select-trigger-text');
      this.searchInput = this.wrapper.querySelector('.custom-select-search-input');
      this.optionsContainer = this.wrapper.querySelector('.custom-select-options');
      this.optionsList = this.wrapper.querySelectorAll('.custom-select-option');
      
      // Store placeholder
      if (this.trigger) {
        this.placeholder = this.triggerText?.textContent || 'Select option';
        this.trigger.dataset.placeholder = this.placeholder;
      }
      
      // State
      this.isOpen = false;
      this.selectedValue = '';
      this.selectedLabel = '';

      // Bind methods
      this.toggleDropdown = this.toggleDropdown.bind(this);
      this.closeDropdown = this.closeDropdown.bind(this);
      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.handleOptionClick = this.handleOptionClick.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);
      this.handleClickOutside = this.handleClickOutside.bind(this);
      this.handleSearch = this.handleSearch.bind(this);

      // Initialize
      this.attachEvents();
      this.setupAccessibility();
    }

    attachEvents() {
      // Trigger click
      this.trigger.addEventListener('click', this.handleTriggerClick);
      
      // DIRECT event listeners on each option - THIS IS THE FIX
      this.addOptionListeners();

      // Search input
      if (this.searchInput) {
        this.searchInput.addEventListener('input', this.handleSearch);
        this.searchInput.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.closeDropdown();
          }
          e.stopPropagation();
        });
      }

      // Global events
      document.addEventListener('click', this.handleClickOutside);
      document.addEventListener('keydown', this.handleKeyDown);
    }

    addOptionListeners() {
      this.optionsList.forEach(option => {
        option.removeEventListener('click', this.handleOptionClick);
        option.addEventListener('click', this.handleOptionClick);
      });
    }

    setupAccessibility() {
      // ARIA attributes
      this.trigger.setAttribute('aria-expanded', 'false');
      this.trigger.setAttribute('aria-label', 'Select an option');
      this.trigger.setAttribute('aria-haspopup', 'listbox');
      
      if (this.dropdown) {
        this.dropdown.setAttribute('role', 'listbox');
      }

      // Set initial ARIA for options
      this.optionsList.forEach((option, index) => {
        option.setAttribute('role', 'option');
        option.setAttribute('tabindex', '-1');
        option.setAttribute('aria-selected', 'false');
        if (index === 0) {
          option.setAttribute('id', `${this.wrapper.dataset.selectId || 'custom-select'}-option-${index}`);
        }
      });
    }

    handleTriggerClick(e) {
      e.preventDefault();
      this.toggleDropdown();
    }

    handleOptionClick = (e) => {
      e.preventDefault();
      
      const option = e.currentTarget;
      const value = option.dataset.value;
      const label = option.textContent.trim();

      if (option.classList.contains('disabled')) {
        return;
      }

      console.log('Option clicked:', value, label);
      
      this.setValue(value, label);
      this.closeDropdown();

      // Trigger onChange callback
      if (typeof this.options.onChange === 'function') {
        this.options.onChange({ value, label, originalEvent: e });
      }
    }

    handleKeyDown(e) {
      // Close on Escape
      if (e.key === 'Escape' && this.isOpen) {
        this.closeDropdown();
        e.preventDefault();
      }

      // Navigate with arrow keys when open
      if (this.isOpen && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
        e.preventDefault();
        this.navigateOptions(e.key);
      }

      // Enter key on focused option
      if (this.isOpen && e.key === 'Enter') {
        e.preventDefault();
        const focusedOption = this.dropdown.querySelector('.custom-select-option.focused');
        if (focusedOption && !focusedOption.classList.contains('disabled')) {
          this.handleOptionClick({ currentTarget: focusedOption });
        }
      }
    }

    handleClickOutside(e) {
      if (!this.containerEl.contains(e.target) && this.isOpen) {
        this.closeDropdown();
      }
    }

    handleSearch(e) {
      const searchTerm = e.target.value.toLowerCase();
      
      this.optionsList.forEach(option => {
        const text = option.textContent.toLowerCase();
        const shouldShow = text.includes(searchTerm);
        option.style.display = shouldShow ? 'block' : 'none';
      });

      // Show/hide no results message
      const hasVisibleOptions = Array.from(this.optionsList).some(
        opt => opt.style.display !== 'none' && !opt.classList.contains('disabled')
      );

      let noResultsEl = this.dropdown.querySelector('.custom-select-no-results');
      
      if (!hasVisibleOptions) {
        if (!noResultsEl) {
          noResultsEl = document.createElement('div');
          noResultsEl.className = 'custom-select-option disabled custom-select-no-results';
          noResultsEl.textContent = 'No results found';
          noResultsEl.setAttribute('role', 'option');
          this.optionsContainer.appendChild(noResultsEl);
        }
      } else if (noResultsEl) {
        noResultsEl.remove();
      }
    }

    navigateOptions(direction) {
      const visibleOptions = Array.from(this.optionsList)
        .filter(opt => opt.style.display !== 'none' && !opt.classList.contains('disabled'));
      
      if (visibleOptions.length === 0) return;

      // Remove focused class from all options
      visibleOptions.forEach(opt => opt.classList.remove('focused'));

      // Find current focused index
      const currentIndex = visibleOptions.findIndex(opt => opt.classList.contains('focused'));
      
      let nextIndex;
      if (direction === 'ArrowDown') {
        nextIndex = currentIndex < visibleOptions.length - 1 ? currentIndex + 1 : 0;
      } else {
        nextIndex = currentIndex > 0 ? currentIndex - 1 : visibleOptions.length - 1;
      }

      // Add focus to next option
      visibleOptions[nextIndex].classList.add('focused');
      visibleOptions[nextIndex].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    toggleDropdown() {
      this.isOpen ? this.closeDropdown() : this.openDropdown();
    }

    openDropdown() {
      this.isOpen = true;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.containerEl.classList.add('is-open');
      
      // Position dropdown
      const rect = this.trigger.getBoundingClientRect();
      this.dropdown.style.top = rect.height + 'px';
      
      // Focus search if available
      if (this.searchInput) {
        setTimeout(() => this.searchInput.focus(), 100);
      }

      // Reset search
      if (this.searchInput) {
        this.searchInput.value = '';
        this.optionsList.forEach(opt => opt.style.display = 'block');
      }

      // Remove any no results message
      const noResultsEl = this.dropdown.querySelector('.custom-select-no-results');
      if (noResultsEl) noResultsEl.remove();
    }

    closeDropdown() {
      this.isOpen = false;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.containerEl.classList.remove('is-open');
      
      // Clear search
      if (this.searchInput) {
        this.searchInput.value = '';
        this.optionsList.forEach(opt => opt.style.display = 'block');
      }
    }

    setValue(value, label) {
      this.selectedValue = value;
      this.selectedLabel = label || value;

      // Update trigger text
      if (this.triggerText) {
        this.triggerText.textContent = this.selectedLabel || this.placeholder;
      }

      // Update native select
      if (this.nativeSelect) {
        this.nativeSelect.value = value || '';
        this.nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Update selected state in options
      this.optionsList.forEach(option => {
        if (option.dataset.value === value) {
          option.classList.add('selected');
          option.setAttribute('aria-selected', 'true');
        } else {
          option.classList.remove('selected');
          option.setAttribute('aria-selected', 'false');
        }
      });
    }

    getValue() {
      return {
        value: this.selectedValue,
        label: this.selectedLabel
      };
    }

    reset() {
      this.setValue('', this.placeholder);
    }

    disable(disabled = true) {
      if (disabled) {
        this.containerEl.classList.add('is-disabled');
        this.trigger.setAttribute('disabled', 'disabled');
        this.trigger.setAttribute('aria-disabled', 'true');
        this.trigger.style.pointerEvents = 'none';
        this.trigger.style.opacity = '0.6';
      } else {
        this.containerEl.classList.remove('is-disabled');
        this.trigger.removeAttribute('disabled');
        this.trigger.setAttribute('aria-disabled', 'false');
        this.trigger.style.pointerEvents = '';
        this.trigger.style.opacity = '';
      }
    }

    setLoading(loading = true) {
      if (loading) {
        this.containerEl.classList.add('is-loading');
        this.trigger.setAttribute('aria-busy', 'true');
      } else {
        this.containerEl.classList.remove('is-loading');
        this.trigger.setAttribute('aria-busy', 'false');
      }
    }

    setOptions(options) {
      if (!this.optionsContainer) return;

      this.optionsContainer.innerHTML = '';

      options.forEach(opt => {
        const optionEl = document.createElement('div');
        optionEl.className = 'custom-select-option';
        optionEl.dataset.value = opt.value;
        optionEl.textContent = opt.label;
        optionEl.setAttribute('role', 'option');
        this.optionsContainer.appendChild(optionEl);
      });

      // Update options list reference
      this.optionsList = this.wrapper.querySelectorAll('.custom-select-option');
      
      // Re-attach ARIA attributes
      this.optionsList.forEach((option, index) => {
        option.setAttribute('role', 'option');
        option.setAttribute('tabindex', '-1');
        option.setAttribute('aria-selected', 'false');
      });

      // RE-ATTACH CLICK LISTENERS - CRITICAL
      this.addOptionListeners();
    }

    destroy() {
      // Remove event listeners
      this.trigger.removeEventListener('click', this.handleTriggerClick);
      document.removeEventListener('click', this.handleClickOutside);
      document.removeEventListener('keydown', this.handleKeyDown);
      
      if (this.searchInput) {
        this.searchInput.removeEventListener('input', this.handleSearch);
      }

      this.optionsList.forEach(option => {
        option.removeEventListener('click', this.handleOptionClick);
      });

      // Clean up
      this.container = null;
      this.wrapper = null;
      this.containerEl = null;
      this.trigger = null;
      this.dropdown = null;
      this.nativeSelect = null;
      this.triggerText = null;
      this.searchInput = null;
      this.optionsList = null;
    }
  }

  /* ===========================
       CONFIGURATION
    =========================== */
  const CONFIG = window.fitmentWidgetData?.config || {};
  const fitmentData = window.fitmentWidgetData?.fitmentData || {};
  

  // HUB PAGES — pages where a fitment search should NOT redirect. The vehicle is
  // stored + all matching handles are prefetched (exactly as a normal search), then
  // the widget just shows its "selected vehicle" summary and stays put. The user
  // then clicks a collection under this hub (e.g. a bulb collection under
  // /pages/car-bulbs) and vehicle-collection-filter.js filters that collection's
  // cards against the already-cached handle list. Add a new hub with one line.
  const HUB_PAGES = ["/pages/car-parts", "/pages/car-bulbs"];
  const IS_HUB_PAGE = HUB_PAGES.includes(window.location.pathname);

  const PAGE_CONTEXT = {
    isCollection:
      window.location.pathname.startsWith("/collections") ||
      window.location.pathname === "/pages/vehicle-search" ||
      window.location.pathname === "/pages/car-parts" ||
      window.location.pathname === "/pages/car-bulbs",
  };
  
  console.log("Page context:", PAGE_CONTEXT);
  
  const EFFECTIVE_LAYOUT =
    PAGE_CONTEXT.isCollection && CONFIG.collectionLayout
      ? CONFIG.collectionLayout
      : CONFIG.layout || 'horizontal';

  const STORAGE_KEYS = {
    active: "vehicle_fitment_active",
    proxyResponse: "vehiclesDon",
    garage: "vehicle_garage_items",
  };

  /* ===========================
       DATA
    =========================== */
  const lookups = {
    makes: fitmentData.options_lookup?.make || [],
    models: fitmentData.options_lookup?.model || [],
    engines: fitmentData.options_lookup?.engine || [],
    years: fitmentData.options_lookup?.year || [],
  };

  /* ===========================
       ELEMENTS
    =========================== */
  const elements = {
    root: document.querySelector(".fw"),
    
    // Custom select wrappers - Horizontal
    makeSelect: document.getElementById("fw-make-select"),
    modelSelect: document.getElementById("fw-model-select"),
    engineSelect: document.getElementById("fw-engine-select"),
    yearSelect: document.getElementById("fw-year-select"),
    
    // Custom select wrappers - Vertical
    makeSelectVertical: document.getElementById("fw-make-select-vertical"),
    modelSelectVertical: document.getElementById("fw-model-select-vertical"),
    engineSelectVertical: document.getElementById("fw-engine-select-vertical"),
    yearSelectVertical: document.getElementById("fw-year-select-vertical"),
    
    // Original elements (keep for backward compatibility)
    make: document.getElementById("fw-make"),
    model: document.getElementById("fw-model"),
    engine: document.getElementById("fw-engine"),
    year: document.getElementById("fw-year"),
    makeVertical: document.getElementById("fw-make-vertical"),
    modelVertical: document.getElementById("fw-model-vertical"),
    engineVertical: document.getElementById("fw-engine-vertical"),
    yearVertical: document.getElementById("fw-year-vertical"),
    
    plate: document.getElementById("fw-plate"),
    plateVertical: document.getElementById("fw-plate-vertical"),
    
    searchBtn: document.getElementById("fw-search"),
    plateSearchBtn: document.getElementById("fw-search-plate"),
    searchBtnVertical: document.getElementById("fw-search-vertical"),
    plateSearchBtnVertical: document.getElementById("fw-search-plate-vertical"),
    
    toggleBtn: document.getElementById("fw-toggle-mode"),
    toggleBtnAlt: document.getElementById("fw-toggle-mode-alt"),
    
    summary: document.getElementById("fw-summary"),
    skeleton:document.getElementById("fw-skeleton"),
    inner:document.getElementById("fw-inner"),
    summaryText: document.getElementById("fw-selected-text"),
    verticalSummary: document.getElementById("fw-vertical-summary"),
    verticalSummaryText: document.getElementById("fw-vertical-selected-text"),
    
    findPartsBtn: document.getElementById("fw-find-parts"),
    changeBtn: document.getElementById("fw-change"),
    verticalFindPartsBtn: document.getElementById("fw-vertical-find-parts"),
    verticalChangeBtn: document.getElementById("fw-vertical-change"),
    summaryPlateWrapper: document.getElementById('fw-summary-plate-wrapper'),
summaryPlateInput: document.getElementById('fw-summary-plate-input'),
verticalSummaryPlateWrapper: document.getElementById('fw-vertical-summary-plate-wrapper'),
verticalSummaryPlateInput: document.getElementById('fw-vertical-summary-plate-input'),
    
    title: document.querySelector(".fw-title"),
    subtitle: document.querySelector(".fw-subtitle"),

    verticalModeBtns: document.querySelectorAll(".fw-vertical-btn"),
    verticalContents: document.querySelectorAll(".fw-vertical-content"),
    verticalTitles: document.querySelectorAll(".fw-vertical-title"),
    verticalSubtitles: document.querySelectorAll(".fw-vertical-subtitle"),

    // Message Box Elements
    messageBoxHorizontal: document.getElementById("fw-message-box-horizontal"),
    messageBoxHorizontalPlate: document.getElementById("fw-message-box-horizontal-plate"),
    messageBoxVerticalModel: document.getElementById("fw-message-box-vertical-model"),
    successBoxVerticalModel: document.getElementById("fw-success-box-vertical-model"),
    messageBoxVerticalPlate: document.getElementById("fw-message-box-vertical-plate"),
    successBoxVerticalPlate: document.getElementById("fw-success-box-vertical-plate"),
  };

  /* ===========================
       CUSTOM SELECT INSTANCES
    =========================== */
  const customSelects = {};

  function initializeCustomSelects() {
    console.log("Initializing custom selects...");

    // Helper function to safely get wrapper
    const getWrapper = (element) => {
      if (!element) return null;
      return element.querySelector('.custom-select-wrapper');
    };

    // Horizontal selects
    if (elements.makeSelect) {
      const wrapper = getWrapper(elements.makeSelect);
      if (wrapper) {
        console.log('Initializing horizontal make select');
        customSelects.make = new CustomSelect(wrapper, {
          onChange: ({ value }) => handleMakeChange('horizontal', value)
        });
      }
    }

    if (elements.modelSelect) {
      const wrapper = getWrapper(elements.modelSelect);
      if (wrapper) {
        console.log('Initializing horizontal model select');
        customSelects.model = new CustomSelect(wrapper, {
          onChange: ({ value }) => handleModelChange('horizontal', value)
        });
        if (customSelects.model) customSelects.model.disable(true);
      }
    }

    if (elements.engineSelect) {
      const wrapper = getWrapper(elements.engineSelect);
      if (wrapper) {
        console.log('Initializing horizontal engine select');
        customSelects.engine = new CustomSelect(wrapper, {
          onChange: ({ value }) => handleEngineChange('horizontal', value)
        });
        if (customSelects.engine) customSelects.engine.disable(true);
      }
    }

    if (elements.yearSelect) {
      const wrapper = getWrapper(elements.yearSelect);
      if (wrapper) {
        console.log('Initializing horizontal year select');
        customSelects.year = new CustomSelect(wrapper, {
          onChange: ({ value }) => handleYearChange('horizontal', value)
        });
        if (customSelects.year) customSelects.year.disable(true);
      }
    }

    // Vertical selects
    if (elements.makeSelectVertical) {
      const wrapper = getWrapper(elements.makeSelectVertical);
      if (wrapper) {
        console.log('Initializing vertical make select');
        customSelects.makeVertical = new CustomSelect(wrapper, {
          onChange: ({ value }) => handleMakeChange('vertical', value)
        });
      } else {
        console.log('Make wrapper not found for vertical');
      }
    }

    if (elements.modelSelectVertical) {
      const wrapper = getWrapper(elements.modelSelectVertical);
      if (wrapper) {
        console.log('Initializing vertical model select');
        customSelects.modelVertical = new CustomSelect(wrapper, {
          onChange: ({ value }) => handleModelChange('vertical', value)
        });
        if (customSelects.modelVertical) customSelects.modelVertical.disable(true);
      } else {
        console.log('Model wrapper not found for vertical');
      }
    }

    if (elements.engineSelectVertical) {
      const wrapper = getWrapper(elements.engineSelectVertical);
      if (wrapper) {
        console.log('Initializing vertical engine select');
        customSelects.engineVertical = new CustomSelect(wrapper, {
          onChange: ({ value }) => handleEngineChange('vertical', value)
        });
        if (customSelects.engineVertical) customSelects.engineVertical.disable(true);
      } else {
        console.log('Engine wrapper not found for vertical');
      }
    }

    if (elements.yearSelectVertical) {
      const wrapper = getWrapper(elements.yearSelectVertical);
      if (wrapper) {
        console.log('Initializing vertical year select');
        customSelects.yearVertical = new CustomSelect(wrapper, {
          onChange: ({ value }) => handleYearChange('vertical', value)
        });
        if (customSelects.yearVertical) customSelects.yearVertical.disable(true);
      } else {
        console.log('Year wrapper not found for vertical');
      }
    }

    console.log("Custom selects initialized:", Object.keys(customSelects));
  }

  // Fetches the heavy compressed_rows once, on first use, then caches it.
  // (Removed from page HTML to stay under Google's 2MB limit.)
  let _rowsPromise = null;
  async function ensureCompressedRows() {
    if (fitmentData.compressed_rows) return;           // already loaded
    if (!_rowsPromise) {
      _rowsPromise = fetch("/a/vehicles/fitmentRows", {
        headers: { Accept: "application/json" },
      })
        .then((r) => r.json())
                .then((data) => {
          fitmentData.compressed_rows = data.compressed_rows || [];
          // Populate the decode table from the fetch (deferred from inline HTML).
          if (data.options_lookup) {
            lookups.models  = data.options_lookup.model  || lookups.models;
            lookups.engines = data.options_lookup.engine || lookups.engines;
            lookups.years   = data.options_lookup.year   || lookups.years;
          }
        })
        .catch((err) => {
          console.error("Failed to load fitment rows:", err);
          fitmentData.compressed_rows = [];
        });
    }
    return _rowsPromise;
  }
  
  /* ===========================
       DROPDOWN HANDLER FUNCTIONS
    =========================== */
  /**
   * Dismiss any visible vehicle-select error.
   *
   * Errors no longer auto-hide (see messaging.showModelError / showPlateError), so
   * they are cleared at the moment they stop being relevant — as soon as the user
   * changes a select. That also guarantees a stale error cannot survive a successful
   * retry, which simply lengthening the timeout would not.
   *
   * Called from the handlers rather than a DOM `change` listener because these are
   * CustomSelect components driven by an `onChange` callback — no native change
   * event is ever emitted from the wrapper elements.
   */
  function clearVehicleSelectErrors() {
    messaging.hideHorizontal();
    messaging.hideAllVertical("model");
  }

    async function handleMakeChange(layout, makeIndex) {
    clearVehicleSelectErrors();
    console.log(`Make changed (${layout}):`, makeIndex);
    if (!makeIndex) {
      // Reset dependent selects
      if (layout === 'horizontal') {
        if (customSelects.model) {
          customSelects.model.reset();
          customSelects.model.disable(true);
        }
        if (customSelects.engine) {
          customSelects.engine.reset();
          customSelects.engine.disable(true);
        }
        if (customSelects.year) {
          customSelects.year.reset();
          customSelects.year.disable(true);
        }
      } else {
        if (customSelects.modelVertical) {
          customSelects.modelVertical.reset();
          customSelects.modelVertical.disable(true);
        }
        if (customSelects.engineVertical) {
          customSelects.engineVertical.reset();
          customSelects.engineVertical.disable(true);
        }
        if (customSelects.yearVertical) {
          customSelects.yearVertical.reset();
          customSelects.yearVertical.disable(true);
        }
      }
      return;
    }

    // Get models for selected make
        await ensureCompressedRows();

    const modelIndices = new Set();
    if (fitmentData.compressed_rows) {
      fitmentData.compressed_rows.forEach((row) => {
        const [m, mo] = row.split(" ").map(Number);
        if (m == makeIndex) modelIndices.add(mo);
      });
    }

    const modelOptions = Array.from(modelIndices).map((i) => ({
      value: i.toString(),
      label: lookups.models[i] || `Model ${i}`,
    }));


    // Update model select
  if (layout === 'horizontal') {
  if (customSelects.model) {
    customSelects.model.reset();        // ← ADD THIS
    customSelects.model.setOptions(modelOptions);
    customSelects.model.disable(false);
  }
  if (customSelects.engine) {
    customSelects.engine.reset();
    customSelects.engine.disable(true);
  }
  if (customSelects.year) {
    customSelects.year.reset();
    customSelects.year.disable(true);
  }
} else {
  if (customSelects.modelVertical) {
    customSelects.modelVertical.reset();        // ← ADD THIS
    customSelects.modelVertical.setOptions(modelOptions);
    customSelects.modelVertical.disable(false);
  }
  if (customSelects.engineVertical) {
    customSelects.engineVertical.reset();
    customSelects.engineVertical.disable(true);
  }
  if (customSelects.yearVertical) {
    customSelects.yearVertical.reset();
    customSelects.yearVertical.disable(true);
  }
}
  }

  function handleModelChange(layout, modelIndex) {
    clearVehicleSelectErrors();
    console.log(`Model changed (${layout}):`, modelIndex);
    
    const makeIndex = layout === 'horizontal' 
      ? customSelects.make?.getValue().value
      : customSelects.makeVertical?.getValue().value;

    if (!makeIndex || !modelIndex) {
      if (layout === 'horizontal') {
        if (customSelects.engine) {
          customSelects.engine.reset();
          customSelects.engine.disable(true);
        }
        if (customSelects.year) {
          customSelects.year.reset();
          customSelects.year.disable(true);
        }
      } else {
        if (customSelects.engineVertical) {
          customSelects.engineVertical.reset();
          customSelects.engineVertical.disable(true);
        }
        if (customSelects.yearVertical) {
          customSelects.yearVertical.reset();
          customSelects.yearVertical.disable(true);
        }
      }
      return;
    }

    // Get engines for selected make and model
    const engineIndices = new Set();
    if (fitmentData.compressed_rows) {
      fitmentData.compressed_rows.forEach((row) => {
        const [m, mo, e] = row.split(" ").map(Number);
        if (m == makeIndex && mo == modelIndex) engineIndices.add(e);
      });
    }

    const engineOptions = Array.from(engineIndices).map((i) => ({
      value: i.toString(),
      label: lookups.engines[i] || `Engine ${i}`,
    }));

    console.log(`Setting ${engineOptions.length} engine options for ${layout}`);

    // Update engine select
   if (layout === 'horizontal') {
  if (customSelects.engine) {
    customSelects.engine.reset();        // ← ADD THIS
    customSelects.engine.setOptions(engineOptions);
    customSelects.engine.disable(false);
  }
  if (customSelects.year) {
    customSelects.year.reset();
    customSelects.year.disable(true);
  }
} else {
  if (customSelects.engineVertical) {
    customSelects.engineVertical.reset();        // ← ADD THIS
    customSelects.engineVertical.setOptions(engineOptions);
    customSelects.engineVertical.disable(false);
  }
  if (customSelects.yearVertical) {
    customSelects.yearVertical.reset();
    customSelects.yearVertical.disable(true);
  }
}
  }

  function handleEngineChange(layout, engineIndex) {
    clearVehicleSelectErrors();
    console.log(`Engine changed (${layout}):`, engineIndex);
    
    const makeIndex = layout === 'horizontal' 
      ? customSelects.make?.getValue().value
      : customSelects.makeVertical?.getValue().value;
    const modelIndex = layout === 'horizontal'
      ? customSelects.model?.getValue().value
      : customSelects.modelVertical?.getValue().value;

    if (!makeIndex || !modelIndex || !engineIndex) {
      if (layout === 'horizontal') {
        if (customSelects.year) {
          customSelects.year.reset();
          customSelects.year.disable(true);
        }
      } else {
        if (customSelects.yearVertical) {
          customSelects.yearVertical.reset();
          customSelects.yearVertical.disable(true);
        }
      }
      return;
    }

    // Get years for selected combination
    const yearsSet = new Set();
    if (fitmentData.compressed_rows) {
      fitmentData.compressed_rows.forEach((row) => {
        const [m, mo, e, y] = row.split(" ").map(Number);
        if (m == makeIndex && mo == modelIndex && e == engineIndex) {
          const yearRange = lookups.years[y];
          if (yearRange) {
            const [start, end] = yearRange.split("-").map(Number);
            for (let year = start; year <= end; year++) {
              yearsSet.add(year);
            }
          }
        }
      });
    }

const sortedYears = Array.from(yearsSet).sort((a, b) => b - a);
const maxYear = sortedYears[0];

const yearOptions = sortedYears.map((year) => {
  let label = year.toString();
  if (year === maxYear) {
    label = maxYear === 2025 ? year + ' -' : year + ' +';
  }
  return {
    value: year.toString(),
    label: label,
  };
});

    console.log(`Setting ${yearOptions.length} year options for ${layout}`);

    // Update year select
    if (layout === 'horizontal') {
      if (customSelects.year) {
        customSelects.year.setOptions(yearOptions);
        customSelects.year.disable(false);
      }
    } else {
      if (customSelects.yearVertical) {
        customSelects.yearVertical.setOptions(yearOptions);
        customSelects.yearVertical.disable(false);
      }
    }
  }

  function handleYearChange(layout, year) {
    clearVehicleSelectErrors();
    console.log(`Year changed (${layout}):`, year);
    
    if (!year) return;

    // Auto-submit if configured. The /a/vehicles combined row (.fw--combined, desktop
    // horizontal only) has no Find Parts button after the dropdowns, so Year always
    // submits there; mobile/vertical behaviour is unchanged.
    const combinedRow =
      layout === 'horizontal' &&
      !!elements.root &&
      elements.root.classList.contains('fw--combined');
    if (CONFIG.autoSubmit || combinedRow) {
      const makeIndex = layout === 'horizontal' 
        ? customSelects.make?.getValue().value
        : customSelects.makeVertical?.getValue().value;
      const modelIndex = layout === 'horizontal'
        ? customSelects.model?.getValue().value
        : customSelects.modelVertical?.getValue().value;
      const engineIndex = layout === 'horizontal'
        ? customSelects.engine?.getValue().value
        : customSelects.engineVertical?.getValue().value;

      if (makeIndex && modelIndex && engineIndex && year) {
        if (layout === 'horizontal') {
          vehicleSearch.performModelSearch();
        } else {
          vehicleSearch.performModelSearchVertical();
        }
      }
    }
  }

  /* ===========================
       MESSAGING UTILITY - KEPT INTACT
    =========================== */
  const messaging = {
    types: {
      ERROR: "error",
      SUCCESS: "success",
      WARNING: "warning",
      INFO: "info",
    },

    icons: {
      error: `https://cdn.shopify.com/s/files/1/0949/9443/2370/files/Group_1045.svg?v=1769746878`,
      success: `https://cdn.shopify.com/s/files/1/0949/9443/2370/files/WHEEL.svg?v=1769746827`,
      warning: `https://cdn.shopify.com/s/files/1/0949/9443/2370/files/WHEEL.svg?v=1769746827`,
      info: `https://cdn.shopify.com/s/files/1/0949/9443/2370/files/WHEEL.svg?v=1769746827`,
    },

    classes: {
      error: "fw-message-box-error",
      success: "fw-message-box-success",
      warning: "fw-message-box-warning",
      info: "fw-message-box-info",
    },

    defaults: {
      duration: 3000,
      autoHide: true,
    },

    showHorizontal(type, text, options = {}) {
      const config = { ...this.defaults, ...options };
      const targetElement = elements.messageBoxHorizontal;

      if (!targetElement) {
        console.warn("Horizontal message box element not found");
        return;
      }

      // Cancel any pending fade-out wipe from a PREVIOUS message on this box —
      // otherwise it fires 300ms from now and erases what we are about to write.
      this._cancelPending("horizontal");

      targetElement.innerHTML = `
        <span class="fw-message-icon">
          <img src="${this.icons[type]}" alt="${type} icon" />
        </span>
        ${text}`;

      targetElement.className = "fw-message-horizontal";
      targetElement.classList.add(this.classes[type]);
      targetElement.classList.remove("hidden");

      if (config.autoHide) {
        setTimeout(() => {
          this.hideHorizontal();
        }, config.duration);
      }
    },

    showHorizontalPlate(type, text, options = {}) {
      const config = { ...this.defaults, ...options };
      const targetElement = elements.messageBoxHorizontalPlate;

      if (!targetElement) {
        console.warn("Plate message box element not found");
        return;
      }

      // See _cancelPending — this is what stops clearPlateLoading()'s scheduled wipe
      // from destroying the error message 300ms after it appears.
      this._cancelPending("horizontalPlate");

      targetElement.innerHTML = `
        <span class="fw-message-icon">
          <img src="${this.icons[type]}" alt="${type} icon" />
        </span>
        ${text}`;

      targetElement.className = "fw-message-horizontal";
      targetElement.classList.add(this.classes[type]);
      // if (type !== "info") {
      //   targetElement.classList.add("reg-error");
      // }
      targetElement.classList.remove("hidden");

      if (config.autoHide) {
        setTimeout(() => {
          this.hideHorizontalPlate();
        }, config.duration);
      }
    },

    // ── PENDING-TIMER REGISTRY (2026-08) ────────────────────────────────────
    // 🔴 THE ACTUAL CAUSE of "Vehicle not found" vanishing instantly.
    //
    // Every hide*() sets a 300ms timer to blank innerHTML and RESET className to
    // "... hidden" (the fade-out cleanup). Nothing ever cancelled those timers, so
    // this sequence destroyed the error:
    //
    //   1. clearPlateLoading()  → hideHorizontalPlate() → schedules a wipe at +300ms
    //   2. showPlateError(...)  → writes the error, removes "hidden"   [immediately]
    //   3. +300ms               → the ORPHANED timer fires and wipes the element
    //
    // The error was killed by the LOADING message's cleanup, not by its own timeout —
    // which is why `autoHide: false` alone did not fix it. Every show*() now cancels
    // any pending wipe for the box it is writing to.
    _timers: {},

    _cancelPending(key) {
      if (this._timers[key]) {
        clearTimeout(this._timers[key]);
        this._timers[key] = null;
      }
    },

    _scheduleWipe(key, fn) {
      this._cancelPending(key);
      this._timers[key] = setTimeout(() => {
        this._timers[key] = null;
        fn();
      }, 300);
    },

    hideHorizontal() {
      const targetElement = elements.messageBoxHorizontal;
      if (targetElement) {
        targetElement.classList.add("hidden");
        this._scheduleWipe("horizontal", () => {
          targetElement.innerHTML = "";
          targetElement.className = "fw-message-horizontal hidden";
        });
      }
    },

    hideHorizontalPlate() {
      const targetElement = elements.messageBoxHorizontalPlate;
      if (targetElement) {
        targetElement.classList.add("hidden");
        this._scheduleWipe("horizontalPlate", () => {
          targetElement.innerHTML = "";
          targetElement.className = "fw-message-horizontal hidden";
        });
      }
    },

    showVerticalError(target, text, options = {}) {
      const config = { ...this.defaults, ...options };
      const targetElement =
        target === "model"
          ? elements.messageBoxVerticalModel
          : elements.messageBoxVerticalPlate;

      const flag = config?.flag;
      if (!targetElement) {
        console.warn("Vertical error message box element not found");
        return;
      }

      this._cancelPending(`verticalError:${target}`);

      targetElement.innerHTML = `
        <span class="fw-message-icon error-icon">
          <img src="${this.icons.error}" alt="Error icon" />
        </span>
        ${text}`;

      targetElement.className = "fw-vertical-error-message";
      targetElement.classList.add(
        flag === "newClass" ? "reg-error" : this.classes.error,
      );
      targetElement.classList.remove("hidden");

      if (config.autoHide) {
        setTimeout(() => {
          this.hideVerticalError(target);
        }, config.duration);
      }
    },

    showVerticalSuccess(target, type, text, options = {}) {
      const config = { ...this.defaults, ...options };
      const targetElement =
        target === "model"
          ? elements.successBoxVerticalModel
          : elements.successBoxVerticalPlate;

      if (!targetElement) {
        console.warn("Vertical success message box element not found");
        return;
      }

      this._cancelPending(`verticalSuccess:${target}`);

      targetElement.innerHTML = `<span class='fw-vertical-success-message-content'>
          <span class="fw-message-icon">
            <img class="fw-message-icon" src="${this.icons[type]}" alt="${type} icon" />
          </span>
          ${text}
        </span>`;

      targetElement.className = "fw-vertical-success-message";
      targetElement.classList.add(this.classes[type]);
      targetElement.classList.remove("hidden");

      if (config.autoHide) {
        setTimeout(() => {
          this.hideVerticalSuccess(target);
        }, config.duration);
      }
    },

    hideVerticalError(target) {
      const targetElement =
        target === "model"
          ? elements.messageBoxVerticalModel
          : elements.messageBoxVerticalPlate;

      if (targetElement) {
        targetElement.classList.add("hidden");
        this._scheduleWipe(`verticalError:${target}`, () => {
          targetElement.innerHTML = "";
          targetElement.className = "fw-vertical-error-message hidden";
        });
      }
    },

    hideVerticalSuccess(target) {
      const targetElement =
        target === "model"
          ? elements.successBoxVerticalModel
          : elements.successBoxVerticalPlate;

      if (targetElement) {
        targetElement.classList.add("hidden");
        this._scheduleWipe(`verticalSuccess:${target}`, () => {
          targetElement.innerHTML = "";
          targetElement.className = "fw-vertical-success-message hidden";
        });
      }
    },

    hideAllVertical(target) {
      this.hideVerticalError(target);
      this.hideVerticalSuccess(target);
    },

    hideAll() {
      this.hideHorizontal();
      this.hideHorizontalPlate();
      this.hideAllVertical("model");
      this.hideAllVertical("plate");
    },

    // Persistent for the same reason as showPlateError — cleared when the user
    // changes any of the make/model/engine/year selects.
    showModelError() {
      this.showHorizontal("error", "Invalid details. Please enter all fields", {
        autoHide: false,
      });
    },

    showModelSuccess() {
      this.showHorizontal("success", "Vehicle found! Searching for parts...", {
        duration: 1500,
      });
    },

    showModelLoading() {
      this.showHorizontal(
        "info",
        "Please wait a short moment while we retrieve your vehicle details.",
        {
          autoHide: false,
        },
      );
    },

    clearModelLoading() {
      this.hideHorizontal();
    },

    showModelErrorVertical() {
      this.showVerticalError(
        "model",
        "Invalid details. Please enter all fields.",
        { autoHide: false },
      );
    },

    showModelSuccessVertical() {
      this.showVerticalSuccess(
        "model",
        "success",
        "Vehicle found! Searching for parts...",
        {
          duration: 1500,
        },
      );
    },

    showModelLoadingVertical() {
      this.showVerticalSuccess(
        "model",
        "info",
        "Please wait a short moment.",
        {
          autoHide: false,
        },
      );
    },

    clearModelLoadingVertical() {
      this.hideVerticalSuccess("model");
    },

    // ── ERRORS DO NOT AUTO-HIDE (2026-08) ───────────────────────────────────
    // These used to inherit `defaults.duration = 3000`, so "Vehicle not found"
    // vanished after 3 seconds — while the SUCCESS message ("Registration found!")
    // was given 15000ms and the loading message never hid at all. That is exactly
    // backwards: the success message is transient by nature (the page is about to
    // change), whereas the error is the one the user has to read and act on. Three
    // seconds is easily missed while looking down at the plate field.
    //
    // A longer timeout is not the answer either — an error that lingers after a
    // successful retry is its own annoyance. Instead the message stays until the
    // user starts correcting the input, which is the natural moment to clear it.
    // See the `input` listeners in init() and clearVehicleSelectErrors().
    showPlateError(message = "Invalid registration number. Please enter a valid number.") {
      this.showHorizontalPlate("error", message, { autoHide: false });
    },

    showPlateErrorVertical(message = "Invalid registration number. Please enter a valid number.") {
      this.showVerticalError("plate", message, {
        flag: "newClass",
        autoHide: false,
      });
    },

    showPlateSuccess() {
      this.showHorizontalPlate(
        "success",
        "Registration found! Searching for parts...",
        {
          duration: 15000,
        },
      );
    },

    showPlateSuccessVertical() {
      this.showVerticalSuccess(
        "plate",
        "success",
        "Registration found! Searching for parts...",
        {
          duration: 1500,
        },
      );
    },

    showPlateLoading() {
      this.showHorizontalPlate("info", "Looking up vehicle registration...", {
        autoHide: false,
      });
    },

    showPlateLoadingVertical() {
      this.showVerticalSuccess(
        "plate",
        "info",
        "Looking up vehicle registration...",
        {
          autoHide: false,
          duration: 10000,
        },
      );
    },

    clearPlateLoading() {
      this.hideHorizontalPlate();
    },

    clearPlateLoadingVertical() {
      this.hideVerticalSuccess("plate");
    },
  };

  /* ===========================
       UTILITIES
    =========================== */

  function updateBannerVisibility() {
  const savedVehicle = utils.getActiveVehicle();

  const bannerDesktop = document.querySelector(".banner-wrapper-ymm-selector");
  const bannerMobile = document.querySelector(".banner-wrapper-ymm-selector-mobile");

  const mobile = isMobile();

  if (!savedVehicle) {
    // SHOW based on device
    if (mobile) {
      if (bannerMobile) bannerMobile.classList.remove("hidden");
      if (bannerDesktop) bannerDesktop.classList.add("hidden");
    } else {
      if (bannerDesktop) bannerDesktop.classList.remove("hidden");
      if (bannerMobile) bannerMobile.classList.add("hidden");
    }
  } else {
    // Hide both if vehicle exists
    if (bannerDesktop) bannerDesktop.classList.add("hidden");
    if (bannerMobile) bannerMobile.classList.add("hidden");
  }
}
  const utils = {
    slugify(text) {
      return String(text || "")
        .replace(/,/g, "-")
        .replace(/\//g, "-")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-+|-+$/g, "")
        .trim()
    },

    findYearRange(makeIndex, modelIndex, engineIndex, year) {
      let bestRange = null;
      let smallestRange = Infinity;

      if (!fitmentData.compressed_rows) return null;

      fitmentData.compressed_rows.forEach((row) => {
        const [m, mo, e, y] = row.split(" ").map(Number);

        if (m !== makeIndex || mo !== modelIndex || e !== engineIndex) return;

        const yearRange = lookups.years[y];
        if (!yearRange) return;

        const [start, end] = yearRange.split("-").map(Number);
        if (year < start || year > end) return;

        const rangeSize = end - start;
        if (rangeSize < smallestRange) {
          smallestRange = rangeSize;
          bestRange = yearRange;
        }
      });

      return bestRange;
    },

    getActiveVehicle() {
      try {
        const data = localStorage.getItem(STORAGE_KEYS.active);
        return data ? JSON.parse(data) : null;
      } catch {
        return null;
      }
    },

    setActiveVehicle(vehicle) {
      localStorage.setItem(STORAGE_KEYS.active, JSON.stringify(vehicle));
    },

    addToGarage(vehicle) {
      try {
        const garage = JSON.parse(
          localStorage.getItem(STORAGE_KEYS.garage) || "[]",
        );

        const exists = garage.some(
          (v) =>
            v.makeIndex === vehicle.makeIndex &&
            v.modelIndex === vehicle.modelIndex &&
            v.engineIndex === vehicle.engineIndex &&
            v.year === vehicle.year,
        );

        if (!exists) {
          garage.unshift({
            id: crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(),
            ...vehicle,
            addedAt: Date.now(),
          });
          localStorage.setItem(
            STORAGE_KEYS.garage,
            JSON.stringify(garage.slice(0, 10)),
          );
        }
      } catch (e) {
        console.error('Error adding to garage:', e);
      }
    },

    moveToGarageIfChanged(newVehicle) {
      const current = this.getActiveVehicle();
      if (!current) return;

      const isSame =
        current.makeIndex === newVehicle.makeIndex &&
        current.modelIndex === newVehicle.modelIndex &&
        current.engineIndex === newVehicle.engineIndex &&
        current.year === newVehicle.year;

      if (!isSame) {
        this.addToGarage(current);
      }
    },

    generateVehicleSlug(vehicle) {
  if (!vehicle) return "";

  if (vehicle.type === "registration") {
    // Already human-readable e.g. "Audi A4 B8 Avant 2.0 TDI"
return [vehicle.make, vehicle.model, vehicle.year, vehicle.engine].filter(Boolean).join(' , ');
  }

  // Prefer the direct string fields when present. A manual dropdown search stores
  // makeIndex/modelIndex (resolved via lookups), but the PDP verify-fitment widget
  // stores make/model/engine as STRINGS with no indices — using the index lookup for
  // those returned '' and rendered a blank summary. Fall back to the index lookup
  // only when the string field is absent.
const make   = vehicle.make   || lookups.makes[vehicle.makeIndex]     || '';
const model  = vehicle.model  || lookups.models[vehicle.modelIndex]   || '';
const engine = vehicle.engine || lookups.engines[vehicle.engineIndex] || '';
const year   = vehicle.year?.toString() || vehicle.yearRange || '';
return [make, model, year, engine].filter(Boolean).join(' , ');
},

    resetAllSelects() {
      // Reset horizontal selects
      if (customSelects.make) customSelects.make.reset();
      if (customSelects.model) {
        customSelects.model.reset();
        customSelects.model.disable(true);
      }
      if (customSelects.engine) {
        customSelects.engine.reset();
        customSelects.engine.disable(true);
      }
      if (customSelects.year) {
        customSelects.year.reset();
        customSelects.year.disable(true);
      }

      // Reset vertical selects
      if (customSelects.makeVertical) customSelects.makeVertical.reset();
      if (customSelects.modelVertical) {
        customSelects.modelVertical.reset();
        customSelects.modelVertical.disable(true);
      }
      if (customSelects.engineVertical) {
        customSelects.engineVertical.reset();
        customSelects.engineVertical.disable(true);
      }
      if (customSelects.yearVertical) {
        customSelects.yearVertical.reset();
        customSelects.yearVertical.disable(true);
      }
    }
  };

  /* ===========================
       MODE MANAGEMENT - HORIZONTAL
    =========================== */
  const modeManager = {
    currentMode: "registration",

    init() {
      if (elements.toggleBtn) {
        elements.toggleBtn.addEventListener("click", this.toggleMode.bind(this));
      }
      if (elements.toggleBtnAlt) {
        elements.toggleBtnAlt.addEventListener("click", this.toggleMode.bind(this));
      }
      this.updateToggleButtons();
      
    },

    toggleMode() {
      if (this.currentMode === "model") {
        this.switchToRegistration();
      } else {
        this.switchToModel();
      }
     
    },

    switchToRegistration() {
      this.currentMode = "registration";
      if (elements.root) elements.root.setAttribute("data-active", "registration");
      this.updateToggleButtons();
      if (elements.title) elements.title.style.display = "none";
      if (elements.subtitle) elements.subtitle.style.display = "block";

      if (elements.plate) elements.plate.value = "";
      messaging.hideHorizontal();

      setTimeout(() => elements.plate?.focus(), 100);
    },

    switchToModel() {
      this.currentMode = "model";
      if (elements.root) elements.root.setAttribute("data-active", "model");
      this.updateToggleButtons();
      if (elements.title) elements.title.style.display = "block";
      if (elements.subtitle) elements.subtitle.style.display = "none";

      if (elements.plate) elements.plate.value = "";
      messaging.hideHorizontalPlate();
      utils.resetAllSelects();

      setTimeout(() => customSelects.make?.trigger?.focus(), 100);
    },

    updateToggleButtons() {
      const buttonText = this.currentMode === "model" ? "Search By Registration" : "Select Vehicle Manually";
      if (elements.toggleBtn) elements.toggleBtn.textContent = buttonText;
      if (elements.toggleBtnAlt) elements.toggleBtnAlt.textContent = buttonText;
    },

  };

  /* ===========================
       MODE MANAGEMENT - VERTICAL
    =========================== */
  const modeManagerVertical = {
    currentMode: "registration",

    init() {
      elements.verticalModeBtns.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          const mode = btn.dataset.verticalMode;
          this.switchMode(mode);
        });
      });
    },

    switchMode(mode) {
      this.currentMode = mode;

      elements.verticalModeBtns.forEach((btn) => {
        if (btn.dataset.verticalMode === mode) {
          btn.classList.add("active");
        } else {
          btn.classList.remove("active");
        }
      });

      elements.verticalContents.forEach((content) => {
        if (content.dataset.verticalContent === mode) {
          content.classList.add("active");
        } else {
          content.classList.remove("active");
        }
      });

      elements.verticalTitles.forEach((title) => {
        if (title.dataset.verticalTitle === mode) {
          title.classList.add("active");
        } else {
          title.classList.remove("active");
        }
      });

      elements.verticalSubtitles.forEach((subtitle) => {
        if (subtitle.dataset.verticalTitle === mode) {
          subtitle.classList.add("active");
        } else {
          subtitle.classList.remove("active");
        }
      });

      messaging.hideAllVertical("model");
      messaging.hideAllVertical("plate");

      if (mode === "model") {
        utils.resetAllSelects();
        setTimeout(() => {
          customSelects.makeVertical?.trigger?.focus();
        }, 100);
      } else {
        if (elements.plateVertical) elements.plateVertical.value = "";
        setTimeout(() => {
          elements.plateVertical?.focus();
        }, 100);
      }
    },
  };

  /* ===========================
       VEHICLE SEARCH - KEPT INTACT
    =========================== */
  const vehicleSearch = {
    performModelSearch() {

      const makeValue = customSelects.make?.getValue().value;
      const modelValue = customSelects.model?.getValue().value;
      const engineValue = customSelects.engine?.getValue().value;
      const yearValue = customSelects.year?.getValue().value;

      if (!makeValue || !modelValue || !engineValue || !yearValue) {
        messaging.showModelError();
        return;
      }

      const makeIndex = parseInt(makeValue);
      const modelIndex = parseInt(modelValue);
      const engineIndex = parseInt(engineValue);
      const year = parseInt(yearValue);

      if (isNaN(makeIndex) || isNaN(modelIndex) || isNaN(engineIndex) || isNaN(year)) {
        messaging.showModelError();
        return;
      }

      messaging.showModelLoading();

      // No artificial delays. findYearRange is synchronous, and redirectToSearch
      // already awaits the prefetch internally — the old outer+inner setTimeout(500)
      // pair added a full second of frozen UI for nothing.
      const yearRange = utils.findYearRange(
        makeIndex,
        modelIndex,
        engineIndex,
        year,
      );

      if (!yearRange) {
        messaging.clearModelLoading();
        // showModelError() shows a fixed message and ignores arguments (unchanged
        // from the original — the passed string was always dead).
        messaging.showModelError();
        return;
      }

      const vehicle = {
        makeIndex,
        modelIndex,
        engineIndex,
        make: lookups.makes[makeIndex] || '',
        model: lookups.models[modelIndex] || '',
        engine: lookups.engines[engineIndex] || '',
        year,
        yearRange,
        slug: `...`,
        savedAt: Date.now(),
      };

      utils.moveToGarageIfChanged(vehicle);
      utils.addToGarage(vehicle);
      utils.setActiveVehicle(vehicle);

      messaging.showModelSuccess();
      this.redirectToSearch(vehicle);
    },

    performModelSearchVertical() {
      const makeValue = customSelects.makeVertical?.getValue().value;
      const modelValue = customSelects.modelVertical?.getValue().value;
      const engineValue = customSelects.engineVertical?.getValue().value;
      const yearValue = customSelects.yearVertical?.getValue().value;

      if (!makeValue || !modelValue || !engineValue || !yearValue) {
        messaging.showModelErrorVertical();
        return;
      }

      const makeIndex = parseInt(makeValue);
      const modelIndex = parseInt(modelValue);
      const engineIndex = parseInt(engineValue);
      const year = parseInt(yearValue);

      if (isNaN(makeIndex) || isNaN(modelIndex) || isNaN(engineIndex) || isNaN(year)) {
        messaging.showModelErrorVertical();
        return;
      }

      messaging.showModelLoadingVertical();

      setTimeout(() => {
        const yearRange = utils.findYearRange(
          makeIndex,
          modelIndex,
          engineIndex,
          year,
        );
        
        if (!yearRange) {
          messaging.clearModelLoadingVertical();
          messaging.showModelErrorVertical(
            "No matching vehicle found. Please check your selections.",
          );
          return;
        }

       const vehicle = {
  makeIndex,
  modelIndex,
  engineIndex,
  make: lookups.makes[makeIndex] || '',
  model: lookups.models[modelIndex] || '',
  engine: lookups.engines[engineIndex] || '',
  year,
  yearRange,
  slug: `...`,
  savedAt: Date.now(),
};

        utils.moveToGarageIfChanged(vehicle);
        utils.addToGarage(vehicle);
        utils.setActiveVehicle(vehicle);

        messaging.showModelSuccessVertical();

        setTimeout(() => {
          this.redirectToSearch(vehicle);
        }, 500);
      }, 500);
    },

    performPlateSearch() {
      if (!elements.plate) return;
      
      const plate = elements.plate.value.trim().toUpperCase();

      if (!plate) {
        messaging.showPlateError("Please enter a registration number");
        return;
      }

      if (!/^[A-Z0-9\s-]{1,10}$/.test(plate)) {
        messaging.showPlateError(
          "Invalid registration format. Please enter a valid UK registration.",
        );
        return;
      }

      messaging.showPlateLoading();
      
      fetch("/a/vehicles/getCartellResponse", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          registrationNumber: plate,
        }),
      })
        .then((response) => {
          if (!response.ok) throw new Error("Network response was not ok");
          return response.json();
        })
        .then((data) => {
          messaging.clearPlateLoading();

          if (!data.success || !data.vehicles || !data.vehicles[0]) {
            messaging.showPlateError(
              "Vehicle not found. Please check the registration number and try again.",
            );
            return;
          }

          const vehicleData = data.vehicles[0];

          const vehicle = {
            type: "registration",
            registrationNumber: vehicleData.registrationNumber,
            make: vehicleData.make,
            model: vehicleData.model,
            engine: vehicleData.engine,
            rawCarName: vehicleData.rawCarName,
            slug: utils.slugify(vehicleData.rawCarName || `${vehicleData.make} ${vehicleData.model}`),
            savedAt: Date.now(),
            year: vehicleData.year,
          };

          utils.setActiveVehicle(vehicle);
            utils.addToGarage(vehicle);
          // Keep the "Registration found! Searching for parts..." message visible
          // THROUGH the prefetch below — do NOT clear it and do NOT insert an
          // artificial delay. The old setTimeout(500) added a dead half-second of
          // frozen UI before the prefetch even started; the prefetch itself is the
          // only wait, and the message covers it so the widget never looks idle.
          messaging.showPlateSuccess();
          localStorage.setItem(STORAGE_KEYS.proxyResponse, JSON.stringify(data.vehicles));

          const isSpecificCollection =
            window.location.pathname.startsWith("/collections") &&
            !window.location.pathname.match(/\/collections\/all(\/|$)/);

          (async () => {
            await prefetchAndSaveVehicleHandles(
              vehicle.make || '',
              vehicle.model || '',
              vehicle.engine || '',
              String(vehicle.year || '')
            );
            if (isSpecificCollection) {
              const currentUrl = new URL(window.location.href);
              currentUrl.searchParams.set('make', encodeURIComponent(vehicle.make || ''));
              currentUrl.searchParams.delete('show-all');
              currentUrl.searchParams.set('model', encodeURIComponent(vehicle.model || ''));
              currentUrl.searchParams.set('engine', encodeURIComponent(vehicle.engine || ''));
              currentUrl.searchParams.set('year', encodeURIComponent(vehicle.year || ''));
              currentUrl.searchParams.set('limit', '250');
              window.location.href = currentUrl.toString();
            } else if (IS_HUB_PAGE) {
              // Hub page → stay put: prefetch done, clear the loading message and
              // show the selected-vehicle summary.
              messaging.clearPlateLoading();
              const savedVehicle = utils.getActiveVehicle() || vehicle;
              if (EFFECTIVE_LAYOUT === "vertical") {
                vehicleSearch.showSummaryVertical(savedVehicle);
              } else {
                vehicleSearch.showSummary(savedVehicle);
              }
              updateBannerVisibility();
            } else {
              window.location.href = '/pages/car-parts';
            }
          })();
        })
        .catch((error) => {
          messaging.clearPlateLoading();
          console.error("Error:", error);
          messaging.showPlateError(
            "Vehicle not found. Please check the registration number and try again.",
          );
        });
    },

    performPlateSearchVertical() {
      if (!elements.plateVertical) return;
      
      const plate = elements.plateVertical.value.trim().toUpperCase();

      if (!plate) {
        messaging.showPlateErrorVertical("Please enter a registration number");
        return;
      }

      if (!/^[A-Z0-9\s-]{1,10}$/.test(plate)) {
        messaging.showPlateErrorVertical(
          "Invalid registration format. Please enter a valid UK registration.",
        );
        return;
      }

      messaging.showPlateLoadingVertical();

      fetch("/a/vehicles/getCartellResponse", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          registrationNumber: plate,
        }),
      })
        .then((response) => {
          if (!response.ok) throw new Error("Network response was not ok");
          return response.json();
        })
        .then((data) => {
          messaging.clearPlateLoadingVertical();

          if (!data.success || !data.vehicles || !data.vehicles[0]) {
            messaging.showPlateErrorVertical(
              "Vehicle not found. Please check the registration number and try again.",
            );
            return;
          }

          const vehicleData = data.vehicles[0];

          const vehicle = {
            type: "registration",
            registrationNumber: vehicleData.registrationNumber,
            rawCarName: vehicleData.rawCarName,
            make: vehicleData.make,
            model: vehicleData.model,
            engine: vehicleData.engine,
            slug: utils.slugify(vehicleData.rawCarName || `${vehicleData.make} ${vehicleData.model}`),
            savedAt: Date.now(),
            year: vehicleData.year,
          };

          utils.setActiveVehicle(vehicle);
          utils.addToGarage(vehicle);
          localStorage.setItem(STORAGE_KEYS.proxyResponse, JSON.stringify(data.vehicles));

          // Keep a NON-auto-hiding loading message visible through the prefetch. The
          // old showPlateSuccessVertical() auto-hid after 1.5s, so on mobile the
          // "found" message flashed and vanished into a frozen gap while the prefetch
          // (and the old 1500ms delay) ran. Show the persistent loader instead, and
          // drop the artificial delay — the prefetch is the only real wait.
          messaging.showPlateLoadingVertical();

          const isSpecificCollection =
            window.location.pathname.startsWith("/collections") &&
            !window.location.pathname.match(/\/collections\/all(\/|$)/);

          (async () => {
            await prefetchAndSaveVehicleHandles(
              vehicle.make || '',
              vehicle.model || '',
              vehicle.engine || '',
              String(vehicle.year || '')
            );
            if (isSpecificCollection) {
              const currentUrl = new URL(window.location.href);
              currentUrl.searchParams.set('make', encodeURIComponent(vehicle.make || ''));
              currentUrl.searchParams.delete('show-all');
              currentUrl.searchParams.set('model', encodeURIComponent(vehicle.model || ''));
              currentUrl.searchParams.set('engine', encodeURIComponent(vehicle.engine || ''));
              currentUrl.searchParams.set('year', encodeURIComponent(vehicle.year || ''));
              currentUrl.searchParams.set('limit', '250');
              window.location.href = currentUrl.toString();
            } else if (IS_HUB_PAGE) {
              // Hub page → stay put: clear the loader, show the vehicle summary.
              messaging.clearPlateLoadingVertical();
              const savedVehicle = utils.getActiveVehicle() || vehicle;
              vehicleSearch.showSummaryVertical(savedVehicle);
              updateBannerVisibility();
            } else {
              window.location.href = '/pages/car-parts';
            }
          })();
        })
    .catch((error) => {
      messaging.clearPlateLoadingVertical();
      console.error("Error:", error);
      messaging.showPlateErrorVertical(
        "Vehicle not found. Please check the registration number and try again.",
      );
    });
    },

    showSummary(vehicle) {
  const slugText = utils.generateVehicleSlug(vehicle);
    if (elements.summaryText) elements.summaryText.textContent = slugText;
    if (elements.summary) elements.summary.style.display = 'block';

    if (EFFECTIVE_LAYOUT === 'vertical') {
      const verticalDesign = document.querySelector('.fw-vertical-design');
      if (verticalDesign) verticalDesign.style.display = 'none';
    } else {
      const horizontalDesign = document.querySelector('.fw-horizontal-design');
      const header = document.querySelector('.fw-header');
      if (horizontalDesign) horizontalDesign.style.display = 'none';
      if (header) header.style.display = 'none';
    }
},

   showSummaryVertical(vehicle) {
  const slugText = utils.generateVehicleSlug(vehicle);
  if (elements.verticalSummaryText) elements.verticalSummaryText.textContent = slugText;
  if (elements.verticalSummary) elements.verticalSummary.style.display = 'block';

  if (vehicle && vehicle.type === 'registration' && vehicle.registrationNumber) {
    if (elements.verticalSummaryPlateInput) elements.verticalSummaryPlateInput.value = vehicle.registrationNumber.toUpperCase();
    if (elements.verticalSummaryPlateWrapper) elements.verticalSummaryPlateWrapper.classList.remove('hidden');
  } else {
    if (elements.verticalSummaryPlateWrapper) elements.verticalSummaryPlateWrapper.classList.add('hidden');
    if (elements.verticalSummaryPlateInput) elements.verticalSummaryPlateInput.value = '';
  }

  const verticalDesign = document.querySelector('.fw-vertical-design');
  if (verticalDesign) verticalDesign.style.display = 'none';
},

    hideSummary() {
      if (elements.summaryPlateWrapper) elements.summaryPlateWrapper.classList.add('hidden');
// if (elements.summaryPlateInput) elements.summaryPlateInput.value = '';
// if (elements.verticalSummaryPlateWrapper) elements.verticalSummaryPlateWrapper.classList.add('hidden');
// if (elements.verticalSummaryPlateInput) elements.verticalSummaryPlateInput.value = '';
      localStorage.removeItem(STORAGE_KEYS.active);
      localStorage.removeItem(STORAGE_KEYS.proxyResponse);
      localStorage.removeItem('vehicle_fitment_all_handles');
      const url = new URL(window.location.href);

      url.searchParams.delete('make');
      url.searchParams.delete('model');
      url.searchParams.delete('engine');
      url.searchParams.delete('year');
      url.searchParams.delete('limit');
      
      window.history.replaceState({}, '', url.toString());

      utils.resetAllSelects();

      if (elements.plate) elements.plate.value = "";
      if (elements.plateVertical) elements.plateVertical.value = "";

      messaging.hideAll();

      if (EFFECTIVE_LAYOUT === "vertical") {
        if (elements.verticalSummary) elements.verticalSummary.style.display = "none";
        const verticalDesign = document.querySelector(".fw-vertical-design");
        if (verticalDesign) verticalDesign.style.display = "block";
        modeManagerVertical.switchMode("model");
      } else {
        if (elements.summary) elements.summary.style.display = "none";
        const horizontalDesign = document.querySelector(".fw-horizontal-design");
        const header = document.querySelector(".fw-header");
        if (horizontalDesign) horizontalDesign.style.display = "flex";
        if (header) header.style.display = "flex";
        modeManager.switchToRegistration();
      }
      updateBannerVisibility()
      // Tell the "Shop by fitment" toggle the vehicle is gone so it can flip from
      // "Vehicle specific" to "Show all products". Cross-file via a custom event so
      // neither widget reaches into the other's DOM.
      document.dispatchEvent(new CustomEvent('partra:vehicle-cleared'));
    },

    hideSummaryVertical() {
      if (elements.summaryPlateWrapper) elements.summaryPlateWrapper.classList.add('hidden');
      if (elements.summaryPlateInput) elements.summaryPlateInput.value = '';
      if (elements.verticalSummaryPlateWrapper) elements.verticalSummaryPlateWrapper.classList.add('hidden');
      if (elements.verticalSummaryPlateInput) elements.verticalSummaryPlateInput.value = '';
      localStorage.removeItem(STORAGE_KEYS.active);
      localStorage.removeItem(STORAGE_KEYS.proxyResponse);
      localStorage.removeItem('vehicle_fitment_all_handles');
      const url = new URL(window.location.href);
      url.searchParams.delete('make');
      url.searchParams.delete('model');
      url.searchParams.delete('engine');
      url.searchParams.delete('year');
      url.searchParams.delete('limit');


    window.history.replaceState({}, '', url.toString());

    utils.resetAllSelects();

    if (elements.plate) elements.plate.value = "";
    if (elements.plateVertical) elements.plateVertical.value = "";

      messaging.hideAll();

      if (elements.verticalSummary) elements.verticalSummary.style.display = "none";
      const verticalDesign = document.querySelector(".fw-vertical-design");
      if (verticalDesign) verticalDesign.style.display = "block";
      modeManagerVertical.switchMode("registration");
      updateBannerVisibility()
      // Flip the "Shop by fitment" toggle to "Show all products" (see hideSummary).
      document.dispatchEvent(new CustomEvent('partra:vehicle-cleared'));
    },

    findPartsFromSummary() {
      const vehicle = utils.getActiveVehicle();
      if (!vehicle) {
        alert("No vehicle selected");
        return;
      }
      this.redirectToSearch(vehicle);
    },

   async redirectToSearch(vehicle) {
      let make, model, engine, year;

      if (vehicle.type === "registration" || vehicle.registrationNumber) {
        make = encodeURIComponent(vehicle.make || "");
        model = encodeURIComponent(vehicle.model || "");
        engine = encodeURIComponent(vehicle.engine || "");
        year = encodeURIComponent(vehicle.year || "");
      } else {
        make = encodeURIComponent(lookups.makes[vehicle.makeIndex] || "");
        model = encodeURIComponent(lookups.models[vehicle.modelIndex] || "");
        engine = encodeURIComponent(lookups.engines[vehicle.engineIndex] || "");
        year = encodeURIComponent(vehicle.year || "");
      }

      const vehicleData = [
        {
          make: make,
          model: model,
          engine: engine,
          year: year,
          ...(vehicle.kType && { kType: vehicle.kType }),
          ...(vehicle.registrationNumber && {
            registrationNumber: vehicle.registrationNumber,
          }),
        },
      ];

      localStorage.setItem(STORAGE_KEYS.proxyResponse, JSON.stringify(vehicleData));
      console.log("Saved to vehiclesDon:", vehicleData);


       await prefetchAndSaveVehicleHandles(
    decodeURIComponent(make),
    decodeURIComponent(model),
    decodeURIComponent(engine),
    decodeURIComponent(year)
  );


      const isSpecificCollection =
        window.location.pathname.startsWith("/collections") &&
        !window.location.pathname.match(/\/collections\/all(\/|$)/);

      if (isSpecificCollection) {
        // On a real collection page → stay and filter it by the vehicle.
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.delete('show-all');
        currentUrl.searchParams.set("make", make);
        currentUrl.searchParams.set("model", model);
        currentUrl.searchParams.set("engine", engine);
        currentUrl.searchParams.set("year", year);
        currentUrl.searchParams.set("limit", "250");
        window.location.href = currentUrl.toString();
      } else if (IS_HUB_PAGE) {
        // Hub page (car-parts / car-bulbs) → DO NOT redirect. The vehicle is saved
        // and handles are prefetched above; just show the summary so the user sees
        // the search worked, then they pick a collection which filters locally.
        const savedVehicle = utils.getActiveVehicle() || vehicle;
        if (EFFECTIVE_LAYOUT === "vertical") {
          this.showSummaryVertical(savedVehicle);
        } else {
          this.showSummary(savedVehicle);
        }
        updateBannerVisibility();
      } else {
        // Anywhere else (home, /collections/all, arbitrary page) → the car-parts hub.
        window.location.href = "/pages/car-parts";
      }
    },
  };
async function prefetchAndSaveVehicleHandles(make, model, engine, year) {
  try {
    const params = new URLSearchParams({
      make: make || '',
      model: model || '',
      engine: engine || '',
      year: year || '',
    });
    const url = `/a/vehicles/vehicleSearchJson?${params.toString()}`;
    console.log('[prefetch] Fetching all product handles:', url);
    const response = await fetch(url);
    if (!response.ok) throw new Error('prefetch response not ok: ' + response.status);
    const data = await response.json();
   const handles = (data.all_product_handles || data.product_handles || []);
const handlesToSave = handles.length === 0 ? ['no-handles'] : handles;
localStorage.setItem('vehicle_fitment_all_handles', JSON.stringify({ handles: handlesToSave, timestamp: Date.now() }));
    console.log('[prefetch] Saved', handles.length, 'handles to vehicle_fitment_all_handles');
    return handles;
  } catch (err) {
    console.warn('[prefetch] Failed to prefetch vehicle handles:', err);
    return [];
  }
}
 function isMobile() {
    return window.innerWidth <= 768; 
  }
  /* ===========================
       INITIALIZATION
    =========================== */
 function init() {
    console.log("Initializing Fitment Widget with Custom Selects");
    const savedVehicle = utils.getActiveVehicle();
    updateBannerVisibility();
     
  if (savedVehicle) {
 
  // Vehicle exists - show summary immediately, no skeleton needed
  if (elements.inner) elements.inner.classList.remove("hidden");
  if (elements.skeleton) elements.skeleton.classList.add("hidden");
  
  // Show the appropriate summary based on layout
  const slugText = utils.generateVehicleSlug(savedVehicle);
  
  if (EFFECTIVE_LAYOUT === "vertical") {
      const horizontalDesign = document.querySelector(".fw-horizontal-design");
    const header = document.querySelector(".fw-header");
    if (horizontalDesign) horizontalDesign.style.display = "none";
    if (header) header.style.display = "none";
    if (elements.verticalSummaryText) {
      elements.verticalSummaryText.textContent = slugText;
    }
    if (savedVehicle.type === 'registration' && savedVehicle.registrationNumber) {
  if (elements.verticalSummaryPlateInput) elements.verticalSummaryPlateInput.value = savedVehicle.registrationNumber.toUpperCase();
  if (elements.verticalSummaryPlateWrapper) elements.verticalSummaryPlateWrapper.classList.remove('hidden');
}
    if (elements.verticalSummary) {
      elements.verticalSummary.style.display = "block";
    }
    const verticalDesign = document.querySelector(".fw-vertical-design");
    if (verticalDesign) {
      verticalDesign.style.display = "none";
    }

  
    
  } else {
    if (elements.summaryText) {
      elements.summaryText.textContent = slugText;
    }
    if (elements.summary) {
      elements.summary.style.display = "block";
    }
      if (savedVehicle.type === 'registration' && savedVehicle.registrationNumber) {
  if (elements.summaryPlateInput) elements.summaryPlateInput.value = savedVehicle.registrationNumber.toUpperCase();
  if (elements.summaryPlateWrapper) elements.summaryPlateWrapper.classList.remove('hidden');
}
  
  }
} else {
  // No vehicle - show the selection form immediately
  if (elements.inner) elements.inner.classList.remove("hidden");
  if (elements.skeleton) elements.skeleton.classList.add("hidden");
  
  // Make sure summary is hidden
  if (elements.summary) elements.summary.style.display = "none";
  if (elements.verticalSummary) elements.verticalSummary.style.display = "none";
}
    // Initialize custom selects first
    initializeCustomSelects();
    
    // Initialize mode managers
    modeManager.init();
    modeManagerVertical.init();

        (async function applyPrefill() {
      if (savedVehicle) return;
      var host = document.querySelector('[data-prefill-make]');
      if (!host) return;

      var makeIdx = host.getAttribute('data-prefill-make');
      var modelIdx = host.getAttribute('data-prefill-model');
      var engineIdx = host.getAttribute('data-prefill-engine');
      if (!makeIdx) return;

      var verticalDesignEl = document.querySelector('.fw-vertical-design');
      var horizontalDesignEl = document.querySelector('.fw-horizontal-design');
      var visible = function (el) {
        return !!el && el.offsetParent !== null;
      };
      var vertical =
        EFFECTIVE_LAYOUT === 'vertical' ||
        (visible(verticalDesignEl) && !visible(horizontalDesignEl)) ||
        (isMobile() && !!verticalDesignEl);

      var mm = vertical ? modeManagerVertical : modeManager;
      if (mm && typeof mm.switchToModel === 'function') {
        mm.switchToModel();
      } else if (mm && typeof mm.switchMode === 'function') {
        mm.switchMode('model');
      }

      var sel = function (base) {
        return vertical ? customSelects[base + 'Vertical'] : customSelects[base];
      };
      var layout = vertical ? 'vertical' : 'horizontal';

      var pick = async function (base, idx, handler) {
        if (!idx) return false;
        var cs = sel(base);
        if (!cs) return false;
        var label = (lookups[base + 's'] || [])[Number(idx)];
        if (!label) return false;
        cs.setValue(String(idx), label);
        await handler(layout, String(idx));
        return true;
      };

      if (!(await pick('make', makeIdx, handleMakeChange))) return;
      if (!(await pick('model', modelIdx, handleModelChange))) return;
      if (engineIdx && typeof handleEngineChange === 'function') {
        await pick('engine', engineIdx, handleEngineChange);
      }
    })();

    

    // Handle icon clicks in vertical buttons
    const iconButtons = document.querySelectorAll(".fw-vertical-btn");
    iconButtons.forEach((button) => {
      const icon = button.querySelector("svg");
      if (icon) {
        icon.addEventListener("click", function (event) {
          event.stopPropagation();
        });
      }
    });

    // Placeholder handlers for plate inputs
    if (elements.plate) {
      elements.plate.addEventListener("focus", function () {
        this.removeAttribute("placeholder");
      });

      elements.plate.addEventListener("blur", function () {
        if (!this.value.trim()) {
          this.setAttribute("placeholder", "ENTER REG");
        }
      });
    }

    if (elements.plateVertical) {
      elements.plateVertical.addEventListener("focus", function () {
        this.removeAttribute("placeholder");
      });

      elements.plateVertical.addEventListener("blur", function () {
        if (!this.value.trim()) {
          this.setAttribute("placeholder", "ENTER REG");
        }
      });
    }

    // ── CLEAR PLATE ERRORS WHEN THE USER STARTS CORRECTING (2026-08) ────────
    // Plate errors no longer auto-hide (see messaging.showPlateError). They are
    // dismissed here instead — the moment the user edits the registration is exactly
    // when the previous error stops being relevant, and it means a stale error can
    // never survive a successful retry.
    //
    // Scoped to the plate boxes (not hideAll) so typing a registration cannot wipe an
    // unrelated model-side message, and vice versa.
    if (elements.plate) {
      elements.plate.addEventListener("input", () => {
        messaging.hideHorizontalPlate();
      });
    }
    if (elements.plateVertical) {
      elements.plateVertical.addEventListener("input", () => {
        messaging.hideAllVertical("plate");
      });
    }

    // Button event listeners
    if (elements.searchBtn) {
      elements.searchBtn.addEventListener("click", () =>
        vehicleSearch.performModelSearch(),
      );
    }
    
    if (elements.plateSearchBtn) {
      elements.plateSearchBtn.addEventListener("click", () =>
        vehicleSearch.performPlateSearch(),
      );
    }
    
    if (elements.findPartsBtn) {
      elements.findPartsBtn.addEventListener("click", () =>
        vehicleSearch.findPartsFromSummary(),
      );
    }
    
    if (elements.changeBtn) {
      elements.changeBtn.addEventListener("click", () =>
        vehicleSearch.hideSummary(),
      );
    }

    if (elements.searchBtnVertical) {
      elements.searchBtnVertical.addEventListener("click", () =>
        vehicleSearch.performModelSearchVertical(),
      );
    }
    
    if (elements.plateSearchBtnVertical) {
      elements.plateSearchBtnVertical.addEventListener("click", () =>
        vehicleSearch.performPlateSearchVertical(),
      );
    }
    
    if (elements.verticalFindPartsBtn) {
      elements.verticalFindPartsBtn.addEventListener("click", () =>
        vehicleSearch.findPartsFromSummary(),
      );
    }
    
    if (elements.verticalChangeBtn) {
      elements.verticalChangeBtn.addEventListener("click", () => {
        if (EFFECTIVE_LAYOUT === "vertical") {
          vehicleSearch.hideSummaryVertical();
        } else {
          vehicleSearch.hideSummary();
        }
      });
    }

    // Enter key handlers
    if (elements.plate) {
      elements.plate.addEventListener("keypress", (e) => {
        if (e.key === "Enter") {
          vehicleSearch.performPlateSearch();
        }
      });
    }

    if (elements.plateVertical) {
      elements.plateVertical.addEventListener("keypress", (e) => {
        if (e.key === "Enter") {
          vehicleSearch.performPlateSearchVertical();
        }
      });
    }

    // Check for saved vehicle
    const saved = utils.getActiveVehicle();

    // Show the summary for ANY saved vehicle, however it was saved:
    //   - registration search  → { type:'registration', registrationNumber, ... }
    //   - manual dropdown search → { makeIndex, modelIndex, ... }
    //   - VERIFY-FITMENT modal   → { type:'model', make, model, engine, year }  ← was missed!
    // The old check required registration OR makeIndex/modelIndex, so a vehicle set
    // by the PDP verify-fitment widget (make/model strings, no indices) failed both
    // and the summary was hidden — even though the collection filter treated it as
    // active. Accept make+model strings too (generateVehicleSlug renders them).
    const savedHasNames = !!(saved && saved.make && saved.model);
    if (
      saved &&
      (saved.type === "registration" ||
        (saved.makeIndex !== undefined && saved.modelIndex !== undefined) ||
        savedHasNames)
    ) {
      console.log("Found saved vehicle:", saved);

      utils.resetAllSelects();

      const slugText = utils.generateVehicleSlug(saved);

      if (EFFECTIVE_LAYOUT === "vertical") {
        if (elements.verticalSummaryText) elements.verticalSummaryText.textContent = slugText;
        if (elements.verticalSummary) elements.verticalSummary.style.display = "block";
        const verticalDesign = document.querySelector(".fw-vertical-design");
        if (verticalDesign) verticalDesign.style.display = "none";
        if (saved.type === 'registration' && saved.registrationNumber) {
  if (elements.verticalSummaryPlateInput) elements.verticalSummaryPlateInput.value = saved.registrationNumber.toUpperCase();
  if (elements.verticalSummaryPlateWrapper) elements.verticalSummaryPlateWrapper.classList.remove('hidden');
}
      } else {
        if (elements.summaryText) elements.summaryText.textContent = slugText;
        if (elements.summary) elements.summary.style.display = "block";
        if (saved.type === 'registration' && saved.registrationNumber) {
  if (elements.summaryPlateInput) elements.summaryPlateInput.value = saved.registrationNumber.toUpperCase();
  if (elements.summaryPlateWrapper) elements.summaryPlateWrapper.classList.remove('hidden');
}
        const horizontalDesign = document.querySelector(".fw-horizontal-design");
        const header = document.querySelector(".fw-header");
        if (horizontalDesign) horizontalDesign.style.display = "none";
        if (header) header.style.display = "none";
      }
    } else {
      if (EFFECTIVE_LAYOUT === "vertical") {
        if (elements.verticalSummary) elements.verticalSummary.style.display = "none";
        const verticalDesign = document.querySelector(".fw-vertical-design");
        if (verticalDesign) verticalDesign.style.display = "block";
      } else {
        if (elements.summary) elements.summary.style.display = "none";
        const horizontalDesign = document.querySelector(".fw-horizontal-design");
        const header = document.querySelector(".fw-header");
        if (horizontalDesign) horizontalDesign.style.display = "flex";
        if (header) header.style.display = "flex";
      }
    }
  }

  /* ===========================
       CLEAR SELECTION
    =========================== */
  function clearSelection() {
    localStorage.removeItem(STORAGE_KEYS.active);
    sessionStorage.removeItem("hasJustSelectedVehicle");

    utils.resetAllSelects();

    if (elements.plate) elements.plate.value = "";
    if (elements.plateVertical) elements.plateVertical.value = "";
    messaging.hideAll();

    if (EFFECTIVE_LAYOUT === "vertical") {
      vehicleSearch.hideSummaryVertical();
    } else {
      vehicleSearch.hideSummary();
    }
  }

  /* ===========================
       START APPLICATION
    =========================== */
  if (document.readyState === 'loading') {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }


window.partraShowPlateError = () => {
  if (EFFECTIVE_LAYOUT === 'vertical') {
    messaging.showPlateErrorVertical('Please enter a registration number');
  } else {
    messaging.showPlateError('Please enter a registration number');
  }
};

window.partraShowModelError = () => {
  if (EFFECTIVE_LAYOUT === 'vertical') {
    messaging.showModelErrorVertical();
  } else {
    messaging.showModelError();
  }
};
  
})();


